<template>
  <div class="wrap">
    <h3 class="title">银行卡受理终端采购协议</h3>
    <p class="weight">甲方：北京海科融通支付服务有限公司</p>
    <p class="weight">社会统一信用代码：911101088020867743</p>
    <p class="weight">法定代表人：孟立新</p>
    <p class="weight">联系地址：北京市海淀区西直门北大街甲43号金运大厦A座12层</p>
    <p class="weight">联系人：</p>
    <p class="weight">联系电话：86(10)8268 5056</p>
    <p class="weight">邮箱：</p>
    <p class="weight">乙方：</p>
    <p class="weight">社会统一信用代码：</p>
    <p class="weight">法定代表人：</p>
    <p class="weight">联系地址：</p>
    <p class="weight">联系人：</p>
    <p class="weight">联系电话：</p>
    <p class="weight">邮箱：</p>
    <p>根据《中华人民共和国民法典》及其他相关法律、法规，经甲、乙双方共同协商，签订本协议，并共同遵守。</p>
    <p class="weight">第一条 合作内容</p>
    <p>1、鉴于甲乙双方签订了《支付业务拓展合作协议》（以实际签署的协议名称为准）、乙方参与了甲方编号为<span class="border_bottom"></span>的《<span class="border_bottom"></span>活动政策》（以下简称“政策”），乙方作为甲方的外包服务商为甲方拓展使用银行卡收单业务的特约商户，基于该拓展业务，乙方需向甲方采购银行卡受理终端。</p>
    <p>2、“受理终端”、“终端”是指通过读取或输入银行卡相关信息，发起交易并提示操作方完成的读取或输入银行卡相关信息，发起交易并提示操作方完成的专用设备及其终端程序。包括：POS受理终端、扫码牌、扫码枪、扫码盒等，具体乙方采购的受理终端产品类型以甲方系统记录为准。</p>
    <p>3、乙方可根据实际业务需求在甲方给与的额度（如有）内，向甲方提货。</p>
    <p>4、甲方所提供的货物产品无功能瑕疵，所有配件、说明书齐全。</p>
    <p class="weight">第二条 采购订单的达成与交货</p>
    <p>1、本协议签署后，乙方根据自身需求在甲方给与的额度（如有）内在甲方系统中发起订货申请流程，填写《订货清单》并提交，经甲方审批通过，甲方平台系统中记录的乙方账户下实际发生的《订货清单》作为本协议的订单。</p>
    <p>2、终端单价：系统中约定的终端单价为含税价，该价格已包含运费（不包含物流运输过程中乙方变更收货地址产生的费用，此运费由乙方自行承担）。</p>
    <p>3、乙方在每批次订单下可分批提货，甲方按照乙方每次的提货需求数量发货。</p>
    <p>4、交货地点为乙方在甲方平台收货人信息中登记的收货地址。</p>
    <p>5、货物一经发出交由承运人运输，货物毁损灭失的风险均由乙方承担。</p>
    <p>6、货物装载符合运输方式的要求。每件包装有良好的防潮、防震、防锈和防野蛮装卸等保护措施，以确保货物安全运抵乙方指定地点。</p>
    <p>7、变更指示</p>
    <p>（1）乙方如必须修改协议及订单条款（产品类型、交货数量、交货时间、交货地点等），必须提前向甲方发出书面请示，经甲方同意方可执行。无论甲方是否发货，均有权视情况拒绝乙方的请求。</p>
    <p>（2）若乙方的变更需求超出了协议的总体范围导致了甲方履行协议项下任何义务的费用、时间成本、人力成本等的增加，甲方有权向乙方收取相应费用。</p>
    <p>9、货物的所有权自发货后转移至乙方名下。</p>
    <p>第三条 付款与验收</p>
    <p>1、每批次订单的货物交付后，乙方须立即对该批次产品类型、产品数量、外观等项目进行检验，并登陆平台进行验收合格的确认。自到货后满15个工作日未登陆平台确认验收的，视为全部收货完毕并已验收合格。如乙方在验收中发现产品有任何问题，有权向甲方提出异议。</p>
    <p>2、付款方式：向甲方指定账号转账付款。</p>
    <p>甲方指定收款账号为：</p>
    <p>户名：北京海科融通支付服务有限公司</p>
    <p>开户银行：北京银行中关村营业部</p>
    <p>账号：20000004295500000173102</p>
    <p>3、付款时间：</p>
    <p>☑（1）一次性付清。</p>
    <p>付清后甲方发货。</p>
    <p>□（2）分期付款</p>
    <p>4、首付款、余款的付款金额及付款周期按照乙方参与的政策以及《服务商采购申请》中约定的内容确定。相关款项甲方有权直接从乙方在甲方处的分润等应收账款中进行抵扣。</p>
    <p class="weight">第四条 质量保证与保密义务</p>
    <p>1、产品的质量保证期为自产品验收合格之日起<span class="border_bottom" style="width:40px">十二</span> 个月。</p>
    <p>2、质量保证期内，货物本身质量出现问题的（不包括人为原因导致、自然损耗、不可抗力、意外事件等导致），甲方负责免费维修；因人为原因、自然损耗、意外事件、不可抗力等不可归责于厂商、甲方的原因导致的货物质量出现问题的，甲方如负责更换、维修的，有权按照市场价格向乙方收取费用。</p>
    <p>3、乙方有义务对在本协议签订、履行过程中合法知悉的甲方的商业秘密及其他保密信息予以保护，不得向其他任何第三方泄露，也不得以本协议之外的目的而使用。本协议下的保密义务持续有效。如乙方违背本保密义务的，除应竭力降低损失及防止危害扩大之外，应赔偿甲方因此所遭受的损失。</p>
    <p>4、乙方保证不对终端设备进行下列操作，每台终端设备被发现以下操作一次，乙方须按照本协议相应终端型号采购价格的十倍向甲方支付违约金，违约金不足以弥补损失的，还应赔偿甲方的损失：</p>
    <p>a．对终端设备进行随意加装；</p>
    <p>b．未经甲方同意的情况下对终端设备程序进行修改；</p>
    <p>c．自行灌装未经甲方同意的程序；</p>
    <p>d. 对终端设备进行反向工程。</p>
    <p class="weight">第五条 承诺与保证</p>
    <p>1、基于社会互联网环境的基础、采购流程对于系统的依赖等原因，乙方在此承诺与保证如下：</p>
    <p>（1）认可采购流程自甲方系统发起，认可甲方系统中记载的采购事实的全部内容，不以甲方系统可自行更改、未做公证等原因否认系统数据的真实性；</p>
    <p>（2）认可甲方平台上乙方账户下的所有操作均为乙方的行为，不得以非乙方公司行为（如账号被盗、他人使用等）为由否认其效力；</p>
    <p>（3）认可平台记载有关采购订单的全部内容，包括但不限于采购方主体、采购产品类型、采购单价、采购数量、采购总价、收货人、收货地址；</p>
    <p>（4）认可平台确认收货的方式与事实。</p>
    <p>2、乙方承诺不以所采购的受理终端非己方使用、非已方收货、转售或划拨给其他方等为由拒绝支付货款或主张减免。</p>
    <p class="weight">第六条 不可抗力</p>
    <p>1、本协议所述不可抗力是指由于地震、台风、战争等不能预见、不能避免并不能克服的情形，直接影响本协议的全部或部分履行或者不能按照协议的约定履行时，遇有上述不可抗力情形的一方可以免除相关协议责任。如造成合同根本目的无法实现的，任何一方有权直接解除协议。</p>
    <p>2、如出现不可抗力情况，经双方协商一致，可延长协议履行期、变更协议内容或终止本协议。</p>
    <p>3、不可抗力的出现对于存在付款义务的乙方来说，不当然赋予乙方免除付款义务的权利，经双方协商一致，可以采取合理的解决方案。</p>
    <p class="weight">第七条 违约责任</p>
    <p>1、乙方未能按照约定时间付款，应向甲方支付迟延付款违约金，每迟交一日按未付款金额的万分之八支付违约金。乙方延迟付款超过10日的，甲方有权（以下方式甲方可以视实际情况同时适用）：</p>
    <p>（1）单方解除该批订单或整个合同关系、解除乙方已参与的政策、解除服务商资格及相关协议等；</p>
    <p>（2）宣布未到期的付款全部提前到期；</p>
    <p>（3）将乙方认购的终端全部提前发货并要求乙方全额付款；</p>
    <p>（4）调整乙方的结算底价；</p>
    <p>（5）要求乙方承担相关损失，包括但不限于甲方的采购支出、运输费用、可期待利益、维权的诉讼费、律师费、公证费、评估费、鉴定费、食宿费各类费用。</p>
    <p>如甲方解除采购合同关系、解除该笔订单的，有权选择要求乙方支付所欠货款，或返还原物从而实现债权，如乙方返还原物不足以弥补甲方损失的，仍应赔偿甲方损失，具体方式由甲方决定。</p>
    <p>2、乙方有任何违约行为需要向甲方承担违约责任、赔偿责任的（包括但不限于所欠货款、违约金、赔偿金、费用），甲方有权从应付乙方（包括乙方关联公司账户）的服务费（分润）与其他应付款项中扣除相应款项。</p>
    <p class="weight">第八条 法律的适用与争议的解决</p>
    <p>1、本协议的所有内容受中华人民共和国法律管辖。</p>
    <p>2、因本协议的履行引发纠纷的，乙甲双方应协商解决。协商不能达成一致意见时，任何一方均可向甲方所在地人民法院诉讼解决。</p>
    <p>3、当产生任何争议及任何争议正在诉讼时，除争议事项外，双方应继续行使其剩余的相关权利，履行其协议项下的其他义务。</p>
    <p class="weight">第九条 协议的生效</p>
    <p>1、本协议自甲乙双方签章之日起生效或乙方在甲方系统内发起订货申请并支付完毕对应的机具款项经甲方确认无误后生效。有效期自本协议签署之日至全部义务、责任履行完毕时止。</p>
    <p>2、本协议附件及本协议具有同等法律效力。</p>
    <p>3、本协议一式二份，甲乙双方各持一份，具有同等法律效力。</p>
    <p>（以下无正文）</p>
  </div>

</template>

<script>
  export default {
    created () {
      document.title = "采购协议"
    }
  }
</script>

<style scoped>
  .wrap {
    padding: 0 10px;
  }

  .title {
    text-align: center;
    padding: 10px 0;
  }

  .weight {
    font-weight: bold;
  }

  p {
    line-height: 30px;
  }

  .subTitle {
    line-height: 28px;
    margin-top: 10px;
  }

  .pic {
    position: fixed;
    left: 0;
    bottom: 40%;
    opacity: .7;
  }

  table {
    width: 100%;
    border-spacing: 0;
  }

  .decor {
    text-decoration: underline;
  }
  .border_bottom{
    border-bottom: 1px solid #000;
    display: inline-block;
    width: 100px;
  }
</style>